{
  "valid": "Έγκυρο"
}
